module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "fm1t"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She’s only a bird in a gilded cage,")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A beautiful sight to see.")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You may think she’s happy and free from care.")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She’s not, though she seems to be…")])]), _vm._v(" "), _c('p', {
    staticClass: "fm1at"
  }, [_vm._v("FROM “BIRD IN A GILDED CAGE,”")]), _vm._v(" "), _c('p', {
    staticClass: "fm1a"
  }, [_vm._v("BY ARTHUR J. LAMB AND HARRY VON TILZER, 1900")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027c3731","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Fm01.vue
// module id = 69
// module chunks = 0